module.exports = __webpack_public_path__ + "img/pt-23.47d3c531.jpg";